<template>
  <div class="approve-transfer-stock-to-nhanh">
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Duyệt phiếu chuyển kho sang hệ thống cũ'">
          <template v-slot:preview>
            <div class="col-12 row" style="padding-left: 0px">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Mã phiếu:</span>
                </template>
                <p>{{ codeStockBill }}</p>
              </b-form-group>
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Ngày tạo:</span>
                </template>
                <p>{{ dateCreate }}</p>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Ngày chuyển kho:</span>
                  <span class="text-danger">*</span>
                </template>
                <date-picker
                  v-bind:disabled="status != 1"
                  placeholder="Chọn ngày nhập kho"
                  class="mb-2 mt-2 form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="$v.form.dateImport.$model"
                  :state="validateState('dateImport')"
                  aria-describedby="input-date-feedback"
                ></date-picker>
                <b-form-invalid-feedback id="input-date-feedback"
                  >Vui lòng chọn ngày chuyển kho</b-form-invalid-feedback
                >
              </b-form-group>
            </div>

            <div class="col-12 row" style="padding-left: 0px">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Kho nguồn:</span>
                  <span class="text-danger">*</span>
                </template>
                <b-form-select
                  disabled="true"
                  id="input-1"
                  class="mt-2 select-style"
                  v-model="$v.form.sourceStoreSelected.$model"
                  :options="listInventories"
                  size="sm"
                  required
                  :state="validateState('sourceStoreSelected')"
                  value-field="id"
                  text-field="name"
                  disabled-field="notEnabled"
                  @change="onChangeStore"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled
                      >Chọn kho nguồn</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback"
                  >Vui lòng chọn kho nguồn</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Kho đích:</span>
                  <span class="text-danger">*</span>
                </template>
                <b-form-select
                  id="input-1"
                  class="mt-2 select-style"
                  v-model="$v.form.desStoreSelected.$model"
                  :options="listInventories"
                  :state="validateState('desStoreSelected')"
                  size="sm"
                  required
                  value-field="id"
                  text-field="name"
                  disabled-field="notEnabled"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled
                      >Chọn kho đích</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback"
                  >Vui lòng chọn kho đích</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Tổng tiền:</span>
                </template>
                <p>{{ convertPrice(totalPrice) }}</p>
              </b-form-group>
            </div>
            <div class="col-12 row" style="padding-left: 0px">
              <b-form-group
                id="input-group-1"
                label-for="input-1"
                class="col-6"
              >
                <template>
                  <span>Nội dung:</span>
                </template>
                <b-form-textarea
                  size="sm"
                  id="textarea1"
                  v-model="notes"
                  :placeholder="'Thêm nội dung...'"
                  :rows="3"
                  :max-rows="3"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label-class="font-weight-bolder"
                label-for="input-1"
                class="col-3"
              >
                <template>
                  <span>Người nhập:</span>
                </template>
                <p>{{ createBy }}</p>
              </b-form-group>
            </div>
            <span class="font-weight-bolder">Danh sách sản phẩm:</span>
            <table
              class="table table-bordered table-vertical-center table-hover col-12 mt-4"
            >
              <thead>
                <tr>
                  <th scope="col" class="title-center" style="width: 27%">
                    Tên sản phẩm
                  </th>
                  <th scope="col" class="title-center" style="width: 7%">
                    SL yêu cầu
                  </th>
                  <th scope="col" class="title-center" style="width: 13%">
                    IMEI
                  </th>
                  <th
                    scope="col"
                    class="title-center"
                    style="width: 20%"
                    v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
                  >
                    Đơn giá
                  </th>
                  <th scope="col" class="title-center" style="width: 7%">
                    SL duyệt
                  </th>
                  <th
                    scope="col"
                    class="title-center"
                    style="width: 26%"
                    v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
                  >
                    Thành tiền
                  </th>
                </tr>
              </thead>

              <tbody v-for="item in listProductStock" :key="item.id">
                <ApproveStock
                  v-bind:productItem="item"
                  v-bind:status="status"
                  v-on:save="save"
                  v-on:update="updateItem"
                  v-bind:editState="true"
                  v-bind:canViewOriginalPrice="
                    checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')
                  "
                />
              </tbody>
              <tr>
                <td
                  :colspan="
                    checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW') ? 4 : 3
                  "
                  class="tdTextAlignPrice"
                >
                  Tổng
                </td>
                <td class="tdTextAlignPrice">{{ totalQuantity }}</td>
                <td
                  class="tdTextAlignPrice"
                  v-show="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')"
                >
                  {{ convertPrice(totalPrice) }}
                </td>
              </tr>
            </table>
          </template>
          <template v-slot:foot>
            <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click.once="updateStock()"
              v-if="status === 1"
              >Duyệt</b-button
            >
            <router-link
              to="/require-stock-to-nhanh"
              tag="button"
              v-if="status === 1"
            >
              <b-button
                style="margin-left: 10px; font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                >Hủy</b-button
              >
            </router-link>
            <router-link
              to="/require-stock-to-nhanh"
              tag="button"
              v-if="status !== 1"
            >
              <b-button
                style="font-weight: 600; width: 70px"
                variant="secondary"
                size="sm"
                >Hủy</b-button
              >
            </router-link>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-1.scss';

.approve-transfer-stock-to-nhanh {
  .title-center {
    text-align: center;
  }

  .autosuggest__results ul {
    list-style: none;
    cursor: pointer;
    margin-bottom: 0;
  }

  .autosuggest__results {
    position: absolute;
    background-color: #fff;
    z-index: 1;
    width: 100%;
    border: 1px solid #e0e0e0;
  }

  .autosuggest__results-container {
    position: relative;
    width: 100%;
  }

  #autosuggest__input {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    height: calc(1.35em + 1.1rem + 2px);
    padding: 0.55rem 0.75rem;
    font-size: 0.925rem;
    line-height: 1.35;
    border-radius: 0.28rem;
  }

  #autosuggest__input:focus {
    outline: none !important;
    border: 1px solid #92c5f9;
  }

  .autosuggest__results-item:hover {
    background-color: #ddd;
  }

  .autosuggest__results ul li {
    padding: 8px;
  }
  .tdTextAlignPrice {
    text-align: right !important;
    vertical-align: middle;
    font-weight: 600;
  }
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import ApiService from '@/core/services/api.service';
import ApproveStock from '@/view/components/ApproveStock';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { unMaskPrice, convertPrice } from '@/utils/common';
import localData from '@/utils/saveDataToLocal';
import { getToastInstance } from '@/utils/toastHelper';

export default {
  mixins: [validationMixin],
  data() {
    return {
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px',
      },
      errors: [],
      codeStockBill: '',
      dateCreate: '',
      listInventories: [],
      totalPrice: 0,
      listProduct: [],
      listProductSearch: [],
      count: 0,
      notes: '',
      idStock: '',
      form: {
        sourceStoreSelected: null,
        desStoreSelected: null,
        dateImport: '',
      },
      isNew: true,
      createBy: '',
      status: 0,
      listType: [
        { id: 1, name: 'Xuất trả hàng nhà cung cấp' },
        { id: 2, name: 'Xuất kho bán hàng' },
      ],
      filteredOptionsProduct: [],
      optionsProduct: [
        {
          data: [],
        },
      ],
      searchProduct: '',
      listTypeSearch: [
        {
          id: 1,
          name: 'Tìm sản phẩm',
        },
        {
          id: 2,
          name: 'Tìm theo IMEI',
        },
      ],
      selectTypeSearch: 1,
      listProductStock: [],
      selectedClassProduct: null,
      totalQuantity: 0,
    };
  },
  validations: {
    form: {
      sourceStoreSelected: { required },
      desStoreSelected: { required },
      dateImport: { required },
    },
  },
  components: {
    KTCodePreview,
    ApproveStock,
  },
  created() {
    this.fetchStore();
    this.getStockById();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Phiếu yêu cầu xuất chuyển kho sang hệ thống cũ',
        route: '/require-stock-to-nhanh',
      },
      { title: 'Duyệt phiếu chuyển kho sang hệ thống cũ' },
    ]);
  },
  methods: {
    convertPrice,
    ...getToastInstance(),
    validateState(name) {
      if (!this.isNew) {
        const { $dirty, $error } = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    fetchProduct() {
      this.listProduct = [];
      this.listProductSearch = [];
      ApiService.setHeader();
      ApiService.get(
        `stocks/get-product-by-store?storeId=${this.$v.form.sourceStoreSelected.$model}&searchProduct=${this.searchProduct}`
      ).then(({ data }) => {
        this.optionsProduct[0].data = [];
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProduct[0].data.push(element);
        });
      });
    },
    updateStock: async function () {
      this.isNew = false;
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let listPro = [];
      this.listProductStock.forEach((element) => {
        let item = {
          id: element.id,
          productId: element.proId,
          imeis: element.IMEI.replace(/[\n\r]/g, ', '),
          quantity: element.quantity,
          unitPrice: unMaskPrice(element.price),
        };
        listPro.push(item);
      });
      let data = {
        id: this.idStock,
        listProduct: listPro,
        destinationWarehouse: this.$v.form.desStoreSelected.$model,
      };
      ApiService.setHeader();
      ApiService.post('transferToNhanh/approve-require-stock', data)
        .then(({ data }) => {
          if (data.status === 1) {
            this.listProduct = [];
            this.makeToastSuccess(data.message);
            setTimeout(() => {
              this.$router.push({
                name: 'list-require-stock-to-nhanh',
              });
            }, 1000);
          } else {
            this.makeToastFaile(data.message);
          }
        })
        .catch(({ response }) => {
          this.makeToastFaile(response.$error);
        });
    },
    save(item) {
      this.listProduct[0] = item;
      this.checkTotalMoney();
    },
    checkTotalMoney() {
      this.totalPrice = 0;
      this.totalQuantity = 0;
      this.listProductStock.forEach((element) => {
        let total = element.quantity * unMaskPrice(element.price);
        this.totalPrice += total;
        this.totalQuantity += parseInt(element.quantity);
      });
    },
    fetchStore() {
      ApiService.setHeader();
      ApiService.get(`stores?limit=10000&page=1`).then(({ data }) => {
        this.listInventories = data.data.list_store;
      });
    },
    updateItem(item) {
      this.listProductStock.forEach((element, index) => {
        if (element.id === item.id) {
          this.listProductStock[index].name = item.name;
          this.listProductStock[index].IMEI = item.IMEI;
          this.listProductStock[index].proId = item.proId;
          this.listProductStock[index].price = item.price;
          this.listProductStock[index].quantity = item.quantity;
          this.listProductStock[index].totalPrice = item.totalPrice;
        }
      });
      this.totalPrice = 0;
      this.checkTotalMoney();
    },
    getStockById() {
      let id = this.$route.query.id;
      ApiService.setHeader();
      ApiService.get(`transferToNhanh/${id}`).then(({ data }) => {
        let dataRes = data.data;
        this.codeStockBill = dataRes.code;
        this.dateCreate = moment(String(dataRes.createdAt)).format(
          'HH:mm DD/MM/YYYY'
        );
        this.$v.form.dateImport.$model = moment(
          String(dataRes.transferDate)
        ).format('DD-MM-YYYY');
        this.$v.form.sourceStoreSelected.$model = dataRes.sourceStoreId;
        this.$v.form.desStoreSelected.$model = dataRes.desStoreId;
        this.totalPrice = dataRes.totalAmount;
        this.notes = dataRes.description;
        this.createBy = dataRes.createdBy;
        this.status = dataRes.status;
        this.idStock = dataRes.id;

        dataRes.listDetail.forEach((element) => {
          this.count++;
          let dataItem = {
            id: element.id,
            name: element.productName,
            IMEI: element.productImei.replace(', ', '\n'),
            proId: element.productId,
            price: element.unitPrice,
            quantity: element.quantity,
            totalPrice: element.totalAmount,
            productType: element.productType,
            quantityRequire: element.quantity,
          };
          this.listProductStock.push(dataItem);
        });
        this.fetchProduct();
        this.checkTotalMoney();
      });
    },
    onChangeStore() {
      this.listProductStock = [];
      if (this.selectTypeSearch === 2) {
        this.fetchProductImei();
      } else {
        this.fetchProduct();
      }
    },
    fetchProductImei() {
      this.listProduct = [];
      ApiService.setHeader();
      ApiService.get(
        `stocks/get-product-by-store-imei?storeId=${this.$v.form.sourceStoreSelected.$model}&searchProduct=${this.searchProduct}`
      ).then(({ data }) => {
        this.optionsProduct[0].data = [];
        const products = data.data;
        this.listProduct = products;
        products.map((element) => {
          this.optionsProduct[0].data.push(element);
        });
      });
    },
    onChangeSearchType() {
      if (this.selectTypeSearch === 2) {
        this.fetchProductImei();
      } else {
        this.fetchProduct();
      }
    },
    checkPermission: function (condition) {
      return localData.checkPermission(condition);
    },
  },
};
</script>
